import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { SaveSavedFilterRequest } from './types/save-saved-filter-request.type';
import type { SavedFilter } from './types/saved-filter.type';

/**
 * Replaces a saved filter's mutable fields. Server transactionally clears
 * `isDefault` on sibling saves when this one is set to default.
 *
 * @param instance - Ky HTTP instance.
 * @param id - Saved filter id.
 * @param body - Full saved-filter payload (PUT semantics — send all fields).
 * @returns OperationResultWithData wrapping the updated `SavedFilter`.
 */
export const updateSavedFilter = async (
  instance: KyInstance,
  id: string,
  body: SaveSavedFilterRequest
) => {
  try {
    return await instance
      .put<OperationResultWithData<SavedFilter>>(formatString(Uri.savedFilters.byId, id), {
        json: body,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
